/**
 * In-context guidance surfaces — the pages/dialogs that can carry a "watch the
 * walkthrough" video. A `training_materials` row tagged with one of these keys
 * (surface_key) powers that surface's <VideoHelpButton>.
 *
 * Single source of truth, shared by:
 *  - the admin "Surface" dropdown (publish/bind a video),
 *  - <VideoHelpButton surface=...> props,
 *  - the mount points across the app.
 *
 * MUST stay in sync with ALLOWED_GUIDANCE_SURFACES in identity-service support.py.
 */
export type GuidanceSurface =
  | 'manager-overview'
  | 'manager-objectives'
  | 'checkin-dialogue'
  | 'manager-development'
  | 'manager-analytics'
  | 'member-deep-dive'
  | 'tm-objectives'
  | 'tm-portfolio'
  | 'tm-checkins'
  | 'tm-feedback'
  | 'tm-growth'

export const GUIDANCE_SURFACES: { key: GuidanceSurface; label: string }[] = [
  { key: 'manager-overview', label: 'People Leader — Team Overview' },
  { key: 'manager-objectives', label: 'People Leader — Objectives' },
  { key: 'checkin-dialogue', label: '1:1 Check-in Dialogue' },
  { key: 'manager-development', label: 'People Leader — Team Growth Plans' },
  { key: 'manager-analytics', label: 'People Leader — Analytics' },
  { key: 'member-deep-dive', label: 'Member Deep-Dive' },
  { key: 'tm-objectives', label: 'my Objectives' },
  { key: 'tm-portfolio', label: 'my Impact Portfolio' },
  { key: 'tm-checkins', label: 'my Check-Ins' },
  { key: 'tm-feedback', label: 'In-the-Moment Feedback' },
  { key: 'tm-growth', label: 'my Personalised Growth' },
]

export const GUIDANCE_SURFACE_LABELS = Object.fromEntries(
  GUIDANCE_SURFACES.map((s) => [s.key, s.label]),
) as Record<GuidanceSurface, string>
